import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Clear } from '@material-ui/icons';
import useFormatPhotoTimestamp from '../../hooks/useFormatPhotoTimestamp';

const GalleryItem = ({
  photo, serverTimezone, deleteImage, canEdit, useSwitch, handleSwitch,
}) => {
  const [hide, setHide] = useState(false);
  const hideIfError = shouldHide => (shouldHide ? { display: 'none' } : { marginBottom: '20px', position: 'relative' });
  const tsText = useFormatPhotoTimestamp(photo, serverTimezone);
  return (
    <div id={`photo-${photo.id}`} key={photo.id} style={hideIfError(hide)}>
      <img
        src={photo.photo_uri}
        alt="img"
        onError={() => {
          setHide(true);
        }}
      />
      {
        canEdit && (
          <div style={{
            cursor: 'pointer', position: 'absolute', top: 10, right: 25, display: 'flex',
          }}
          >
            <Clear data-testid="delet-image-button" onClick={() => deleteImage(photo.photo_uri)} style={{ color: 'red', fontSize: 28 }} />
            {useSwitch && (
              <button
                className="fa fa-exchange"
                style={{
                  backgroundColor: '#000a', border: 0, borderRadius: 20, color: 'white', fontSize: 20, padding: '2px 12px',
                }}
                onClick={() => handleSwitch(photo.id)}
              />
            )}
          </div>
        )
      }
      <div>
        {tsText}
      </div>
    </div>
  );
};

GalleryItem.propTypes = {
  serverTimezone: PropTypes.string,
  photo: PropTypes.instanceOf(Object).isRequired,
  deleteImage: PropTypes.func,
  canEdit: PropTypes.bool,
  useSwitch: PropTypes.bool,
  handleSwitch: PropTypes.func,
};

GalleryItem.defaultProps = {
  serverTimezone: 'America/Chicago',
  deleteImage: () => {},
  canEdit: false,
  useSwitch: false,
  handleSwitch: () => {},
};

export default GalleryItem;
